// extracted by mini-css-extract-plugin
export default {"identityDocumentSidePage":"WA7wP","footer":"UaLnT","footerLeft":"Wi9LT"};